<div *ngFor="let course of courses">
  <h6 class="course-name">{{course.courseName}}</h6>
  <div class="row no-gutters nm-1 mb-2">
    <div class="col-3 col-xl-2 mb-2 cursor-pointer px-1" *ngFor="let stage of course.stages" (click)="bookClicked(course, stage)">
      <img class="card-img shadow-lg" [src]="getImageUrl(course, stage)"/>
    </div>
  </div>
</div>
